export const defaultTheme = {
  name: 'default',
  tokens: {
    components: {
      navbar: {
        minHeight: { value: "80px" }
      },
      footer: {
        minHeight: { value: "80px" }
      },
    },
    colors: {
      font: {
        primary: { value: '#0d1a26' },
        secondary: { value: '#fff' }
      },
      brand: {
        primary: {
          10: { value: "rgba(147, 129, 255, 0.1)" },
          20: { value: "rgba(147, 129, 255, 0.2)" },
          40: { value: "rgba(147, 129, 255, 0.4)" },
          60: { value: "rgba(147, 129, 255, 0.6)" },
          80: { value: "rgba(147, 129, 255, 0.8)" },
          90: { value: "rgba(147, 129, 255, 0.9)" },
          100: { value: "rgba(147, 129, 255, 1)" },
        },
        secondary: {
          10: { value: "rgba(184, 184, 255, 0.1)" },
          20: { value: "rgba(184, 184, 255, 0.2)" },
          40: { value: "rgba(184, 184, 255, 0.4)" },
          60: { value: "rgba(184, 184, 255, 0.6)" },
          80: { value: "rgba(184, 184, 255, 0.8)" },
          90: { value: "rgba(184, 184, 255, 0.9)" },
          100: { value: "rgba(184, 184, 255, 1)" },
        },
        detail: {
          10: { value: "rgba(248, 247, 255, 0.1)" },
          20: { value: "rgba(248, 247, 255, 0.2)" },
          40: { value: "rgba(248, 247, 255, 0.4)" },
          60: { value: "rgba(248, 247, 255, 0.6)" },
          80: { value: "rgba(248, 247, 255, 0.8)" },
          90: { value: "rgba(248, 247, 255, 0.9)" },
          100: { value: "rgba(248, 247, 255, 1)" },
        }
      }
    },
    fonts: {
      default: {
        variable: { value: 'Montserrat, sans-serif' },
        static: { value: 'Libre Baskerville, sans-serif' },
      },
    },
  },
}